import {
  AppointableDTO,
  AppointablePatchDTO,
  AppointablePostDTO,
} from "@gymflow/types";

import { AppointableFormValues } from "../types";
import { mapFormValuesToPostDTO } from "./mapFormValuesToPostDTO";

export const mapFormValuesToPatchDTO = (
  formValues: AppointableFormValues,
  clubId: number,
  appointable: AppointableDTO,
): AppointablePatchDTO => {
  const base: AppointablePostDTO = mapFormValuesToPostDTO(formValues, clubId);

  const patch: AppointablePatchDTO = {
    ...base,
    allowOnlineBookings: appointable.allowOnlineBookings,
    allowAppBookings: appointable.allowAppBookings,
    cardUpfront: appointable.cardUpfront,
    capacity: appointable.capacity,
    status: appointable.status,
    slotAlignment: formValues.details.isTopOfTheHour ? "HOUR_START" : "ANYTIME",
  };

  if (
    appointable?.price !== undefined &&
    !["PRICE", "BOTH"].includes(formValues.pricingStructure.typeOfCost)
  ) {
    patch.removePrice = true;
  }

  if (
    appointable?.sessionCost !== undefined &&
    !["CREDITS", "BOTH"].includes(formValues.pricingStructure.typeOfCost)
  ) {
    patch.removeSessionCost = true;
  }

  if (patch.pricingModel === "FREE") {
    patch.removePrice = true;
    patch.removeSessionCost = true;
  }

  return patch;
};
